import React, { useContext, useState } from 'react'
import PrevixLogo from '../../assets/images/PrevixLogoTextHorizontal.svg'
import { BackButton } from '../../components/BackButton'
import { Modal } from '../../components/Modal'
import api from '../../services/api'
import { RecoverPasswordFirstStep } from './components/RecoverPasswordFirstStep'
import { RecoverPasswordSecondStep } from './components/RecoverPasswordSecondStep'
import {
  Container,
  Content,
  LoginFooter,
  LoginImage,
  LogoImage,
  MainContent,
  ResendCode,
} from './styles'

// import { ContextRecoverPasswordProvider } from '../../context/context_recoverPassword'
import { Context } from '../../context/context_recoverPassword'
import { Helmet } from 'react-helmet'

export const RecoverPassword = () => {
  const { recoverPasswordInfos } = useContext(Context)

  const [recoverPasswordStep, setRecoverPasswordStep] = useState('first')
  const [codeSentModal, setCodeSentModal] = useState(false)
  const [passwordChangedSuccessModal, setPasswordChangedSuccessModal] =
    useState(false)
  const [passwordChangedErrorModal, setPasswordChangedErrorModal] =
    useState(false)
  const [codeInvalidModal, setCodeInvalidModal] = useState(false)

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const sendCode = (e) => {
    e.preventDefault()

    if (recoverPasswordInfos.canalType === 'sms') {
      api
        .post('/v1/user/password/recover/sms', {
          sms: recoverPasswordInfos.sms,
        })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error.response)
        })
    } else {
      api
        .post('/v1/user/password/recover/email', {
          email: recoverPasswordInfos.email,
        })
        .then((response) => {
          console.log(response)
          // toggleFunction(openModal)
        })
        .catch((error) => {
          console.log(error.response)
        })
    }
  }

  return (
    <>
      <Helmet>
        <title>Previx - Recuperar senha</title>
        <meta
          name="Previx - Recuperar senha"
          content="Recuperação de senha previx"
        />
      </Helmet>

      <Container>
        <Content>
          <LogoImage src={PrevixLogo} />
          <MainContent>
            <BackButton goTo={'login'} />
            {recoverPasswordStep === 'first' ? (
              <RecoverPasswordFirstStep openModal={setCodeSentModal} />
            ) : (
              <RecoverPasswordSecondStep
                openModalSuccess={setPasswordChangedSuccessModal}
                openModalError={setPasswordChangedErrorModal}
                openModalResendCode={setCodeInvalidModal}
              />
            )}
          </MainContent>
          <LoginFooter>2023 - Powered by Ubicuacloud ©</LoginFooter>
        </Content>
        <LoginImage />
        <Modal.Root
          backgroundcolor="#fff"
          top="50%"
          left="50%"
          height="fit-content"
          width="fit-content"
          borderradius="8px"
          open={codeSentModal}
          setIsOpenController={() => {
            toggleFunction(setCodeSentModal)
            setRecoverPasswordStep('second')
          }}
        >
          <Modal.Header
            onclick={() => {
              toggleFunction(setCodeSentModal)
              setRecoverPasswordStep('second')
            }}
          />
          <Modal.Content
            icon
            value="Código enviado!"
            subvalue="Código encaminhado para o e-mail de seu cadastro, Acesse para prosseguir com a atualização de senha."
          />
          <Modal.Footer>{''}</Modal.Footer>
        </Modal.Root>
        <Modal.Root
          backgroundcolor="#fff"
          top="50%"
          left="50%"
          height="fit-content"
          width="fit-content"
          borderradius="8px"
          open={passwordChangedSuccessModal}
          setIsOpenController={() => {
            toggleFunction(setPasswordChangedSuccessModal)
            window.location.href = '/login'
          }}
        >
          <Modal.Header onclick={setPasswordChangedSuccessModal} />
          <Modal.Content
            icon
            value="Alteração realizada com sucesso!"
            subvalue="Estamos atualizando suas credenciais, ao acessar a conta você já poderá inserir sua nova senha"
          />
          <Modal.Footer>{''}</Modal.Footer>
        </Modal.Root>
        <Modal.Root
          backgroundcolor="#fff"
          top="50%"
          left="50%"
          height="fit-content"
          width="fit-content"
          borderradius="8px"
          open={passwordChangedErrorModal}
          setIsOpenController={() => {
            toggleFunction(setPasswordChangedErrorModal)
          }}
        >
          <Modal.Header onclick={setPasswordChangedSuccessModal} />
          <Modal.Content
            icon
            value="Alteração realizada com sucesso!"
            subvalue="Estamos atualizando suas credenciais, ao acessar a conta você já poderá inserir sua nova senha"
          />
          <Modal.Footer>{''}</Modal.Footer>
        </Modal.Root>
        <Modal.Root
          backgroundcolor="#fff"
          top="50%"
          left="50%"
          height="fit-content"
          width="fit-content"
          borderradius="8px"
          open={codeInvalidModal}
          setIsOpenController={() => {
            toggleFunction(setCodeInvalidModal)
          }}
          padding="0 0 1rem 0"
        >
          <Modal.Header onclick={setCodeInvalidModal} />
          <Modal.Content subvalue="Código inserido incorreto ou expirado." />
          <ResendCode
            onClick={(e) => {
              sendCode(e)
              toggleFunction(setCodeInvalidModal)
            }}
          >
            Encaminhar novo e-mail
          </ResendCode>
          <Modal.Footer>{''}</Modal.Footer>
        </Modal.Root>
      </Container>
    </>
  )
}
